import { handleRequest } from "@helpers";
import { getHeaders } from "./helpers";

const remoteApiUrl = process.env.REACT_APP_REMOTE_API_URL;

const uploadImage = async (file: Blob, name?: string) => {
  const formData = new FormData();
  formData.append("file", file, name);

  const params = {
    url: `${remoteApiUrl}/images`,
    options: {
      ...getHeaders(),
      method: "POST",
      body: formData,
    },
    errorMsg: "Error uploading image",
  };
  return handleRequest(params);
};

export { uploadImage };
